import React from 'react'
import styles from './S2DLayout.scss'
import { Modal } from 'common/styleguide/Modal'
import { ProgressBar } from 'common/ProgressBar'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { CTA } from 'common/styleguide/CTA'
import { styleguideVars as colors } from 'lib/styleguideVars'
import { Msg, commonCTAs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export const S2DLayout = ({
  title,
  subtitle,
  nextText,
  step,
  stepCount,
  children,
  disableNext,
  onClickNext,
  onClickPrev
}) => <StandardLayout>
  <div className={styles.S2DLayout}>
    <Modal
      title={title}
      subtitle={subtitle}
      footer={<Footer
        step={step}
        stepCount={stepCount}
        disableNext={disableNext}
        onClickNext={onClickNext}
        onClickPrev={onClickPrev}
        nextText={nextText} />}
      className={styles.Modal}
      showCloseButton={false}>
      <div className={styles.modalContent}>
        {children}
      </div>
    </Modal>
  </div>
</StandardLayout>

const Footer = ({
  step, stepCount, disableNext, onClickNext, onClickPrev, nextText
}) => <div className={styles.Footer}>
  <div className={styles.steps}>
    <div className={styles.stepText}>
      <span><T id='s2d.step' defaultMessage='Step {step}' values={{ step }} /></span>
      {stepCount && <span>
        <T id='s2d.of' defaultMessage=' of {stepCount}' values={{ stepCount }} description='Please retain spaces' />
      </span>}
    </div>
    <ProgressBar
      width='100px'
      height='4px'
      primaryColor={colors.purple}
      secondaryColor={colors.grey300}
      progress={stepCount ? step / stepCount : 0.25} />
  </div>
  <div className={styles.buttons}>
    {step > 1 && <a onClick={onClickPrev} className={styles.prev}><Msg capitalized m={commonCTAs.previous} /></a>}
    {disableNext
      ? <CTA inline disabled margins={false} data-tip title={disableNext}>
        <Msg capitalized m={commonCTAs.next} />
      </CTA>
      : <CTA onClick={onClickNext} inline margins={false}>
        {nextText || <Msg capitalized m={commonCTAs.next} />}
      </CTA>
    }
  </div>
</div>
